import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const DATE_LABELS = { coffee: '☕ Coffee', dinner: '🍽️ Dinner', lunch: '🥐 Lunch' };

const InvitePreview = ({ invite, choices, onEdit, onContinue, onViewProfile }) => {
  const dateLabel = choices.dateType === 'custom' ? `✨ ${choices.customType}` : (DATE_LABELS[choices.dateType] || choices.dateType);
  const formattedDate = choices.eventDate ? new Date(choices.eventDate + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }) : '';

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="w-full max-w-sm p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">Invitation Summary</h2>
      <p className="text-gray-500 text-sm mb-6 text-center">Review your response before sending</p>
      <div className="bg-white rounded-2xl border border-gray-200 p-5 space-y-4 mb-6">
        <div className="flex items-center gap-3 pb-3 border-b border-gray-100">
          <div className="w-10 h-10 bg-pink-100 rounded-xl flex items-center justify-center">
            <SafeIcon name="Heart" className="text-pink-500" />
          </div>
          <div>
            <p className="text-xs text-gray-400">From</p>
            <p className="font-semibold text-gray-800">{invite.sender_profile?.name || 'Someone special'}</p>
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-400 mb-1">Invitation</p>
          <p className="font-medium text-gray-700">{invite.occasion}</p>
        </div>
        <div>
          <p className="text-xs text-gray-400 mb-1">Your Date Choice</p>
          <p className="font-medium text-gray-700 text-lg">{dateLabel}</p>
        </div>
        <div>
          <p className="text-xs text-gray-400 mb-1">Date & Time</p>
          <p className="font-medium text-gray-700">{formattedDate}</p>
          <p className="text-gray-500">{choices.eventTime}</p>
        </div>
        {choices.message && (
          <div>
            <p className="text-xs text-gray-400 mb-1">Your Note</p>
            <p className="text-gray-700 italic">"{choices.message}"</p>
          </div>
        )}
      </div>
      <div className="space-y-3">
        <button onClick={onViewProfile} className="w-full bg-purple-50 text-purple-600 font-semibold py-3 rounded-xl border border-purple-200 flex items-center justify-center gap-2">
          <SafeIcon name="User" /> View {invite.sender_profile?.name || "their"} Profile
        </button>
        <div className="flex gap-3">
          <button onClick={onEdit} className="flex-1 bg-white border border-gray-200 text-gray-700 font-bold py-4 rounded-xl">Edit</button>
          <button onClick={onContinue} className="flex-[2] bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-pink-200">Continue →</button>
        </div>
      </div>
    </motion.div>
  );
};

export default InvitePreview;